import React from 'react';

import { useIntl } from 'react-intl';

import { ErrorEmptyStateImage } from './images';
import { EmptyStateWrapper, HeaderText, ImageWrapper, StyledActionButtonLink } from './styled';

const ErrorState = () => {
  const { formatMessage } = useIntl();

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <ErrorEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{formatMessage({ id: 'recentItemsFailed' })}</HeaderText>
      <StyledActionButtonLink onClick={window.location.reload}>
        {formatMessage({ id: 'refresh' })}
      </StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};

export default ErrorState;
